function BackButton({ dispatch, index }) {
  if (index === 0) return null;
  return (
    <button
      className="btn btn-back"
      onClick={() => dispatch({ type: "backQuestion" })}
    >
      Back
    </button>
  );
}

export default BackButton;
